export default __webpack_public_path__ + "static/sticker-3fa2487627b8bc9c3a068a8dad30a9d0.svg";